"use strict";
// TEMPORARY: Use the old firebaseManager for immediate compatibility
// TODO: Migrate to modular architecture in phases
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFirebaseInitialized = exports.initializeFirebase = exports.getGoogleProvider = exports.getFirebaseAnalytics = exports.getFirebaseFunctions = exports.getStorageAsync = exports.getFirebaseStorage = exports.getFirebaseAuthAsync = exports.getFirebaseAuth = exports.getDb = exports.getDownloadURL = exports.uploadBytes = exports.ref = exports.firebaseCore = void 0;
var firebaseManager_1 = require("../firebaseManager");
Object.defineProperty(exports, "firebaseCore", { enumerable: true, get: function () { return firebaseManager_1.firebaseManager; } });
var storage_1 = require("firebase/storage");
Object.defineProperty(exports, "ref", { enumerable: true, get: function () { return storage_1.ref; } });
Object.defineProperty(exports, "uploadBytes", { enumerable: true, get: function () { return storage_1.uploadBytes; } });
Object.defineProperty(exports, "getDownloadURL", { enumerable: true, get: function () { return storage_1.getDownloadURL; } });
// Re-export the getters from firebaseManager for backward compatibility
const getDb = () => {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getDb();
};
exports.getDb = getDb;
const getFirebaseAuth = () => {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getAuthSync();
};
exports.getFirebaseAuth = getFirebaseAuth;
const getFirebaseAuthAsync = () => __awaiter(void 0, void 0, void 0, function* () {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getAuth();
});
exports.getFirebaseAuthAsync = getFirebaseAuthAsync;
const getFirebaseStorage = () => {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getStorageSync();
};
exports.getFirebaseStorage = getFirebaseStorage;
const getStorageAsync = () => __awaiter(void 0, void 0, void 0, function* () {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getStorage();
});
exports.getStorageAsync = getStorageAsync;
const getFirebaseFunctions = () => {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getFunctionsSync();
};
exports.getFirebaseFunctions = getFirebaseFunctions;
const getFirebaseAnalytics = () => {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getAnalyticsSync();
};
exports.getFirebaseAnalytics = getFirebaseAnalytics;
const getGoogleProvider = () => {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.getGoogleAuthProvider();
};
exports.getGoogleProvider = getGoogleProvider;
const initializeFirebase = () => __awaiter(void 0, void 0, void 0, function* () {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.initialize();
});
exports.initializeFirebase = initializeFirebase;
const isFirebaseInitialized = () => {
    const { firebaseManager } = require('../firebaseManager');
    return firebaseManager.isReady();
};
exports.isFirebaseInitialized = isFirebaseInitialized;
// Export modular architecture for future migration
__exportStar(require("./core/FirebaseCore"), exports);
__exportStar(require("./types"), exports);
